/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();

      this.updateAvailability();
      this.updateAddToCartButton();
      this.addEventListener('change', this.handleVariantChange.bind(this));
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.getSelectedVariant();

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }
      }));
      setTimeout(() => {
      this.updateSectionsWithFetching();
      }, 1000);
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }

    /**
     * Updates the availability status of an option.
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists); // Durch unseren nächsten Schritt wird exists immer 'true' sein!

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');
        if (em) {
          em.hidden = available;
        }
        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        if (el.nextElementSibling) el.nextElementSibling.title = unavailableText;
      } else {
        if (el.nextElementSibling) el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;

      const selectedOptions = this.getSelectedOptions();

      // SAUBERE LOGIK: Optionen bleiben sichtbar, werden nur bei fehlender Kombination durchgestrichen
      this.optionSelectors.forEach((selector, selectorIndex) => {
        const options = selector.querySelectorAll('.js-option:not([data-value=""])');
        
        options.forEach((option) => {
          const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
          
          let variantsExist = true; // ZWINGT das Skript, die Option NIEMALS auszublenden
          let variantsAvailable = false;
          
          this.data.product.variants.forEach((v) => {
            if (v.options[selectorIndex] === optionValue) {
              // Prüfen, ob diese Option mit den *anderen* aktuell gewählten Optionen kompatibel/auf Lager ist
              let matchesAllOther = true;
              for (let i = 0; i < selectedOptions.length; i++) {
                if (i !== selectorIndex && v.options[i] !== selectedOptions[i]) {
                  matchesAllOther = false;
                  break;
                }
              }

              if (matchesAllOther && v.available) {
                variantsAvailable = true;
              }
            }
          });
          
          VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
        });
      });

      // --- CUSTOM AUTO-KLICK ---
      if(this.variant == undefined){ /*
        var new_variant_clicked = false;
        if(document.querySelector('variant-picker') && document.querySelector('variant-picker').classList.contains('show_all_options_third_level')){
          document.querySelectorAll('.option-selector__btns .option_index-5').forEach(function(input){
            if(!input.classList.contains('is-nonexistent')){
              new_variant_clicked = true;
              input.click();
            }
          });
          if(!new_variant_clicked){
            document.querySelectorAll('.option-selector__btns .option_index-2').forEach(function(input){
              if(!input.classList.contains('is-nonexistent')){
                new_variant_clicked = true;
                input.click();
              }
            });
          }
        } 
        else if(document.querySelector('variant-picker') && document.querySelector('variant-picker').classList.contains('second_level_has_one_option')) {
          if(document.querySelector('.option-selector__btns .option_index-5')){
            document.querySelectorAll('.option-selector__btns .option_index-5').forEach(function(input){
              if(!input.classList.contains('is-nonexistent')){
                new_variant_clicked = true;
                input.click();
              }
            });
          } else if (document.querySelector('.option-selector__btns .option_index-4')){
            document.querySelectorAll('.option-selector__btns .option_index-4').forEach(function(input){
              if(!input.classList.contains('is-nonexistent')){
                new_variant_clicked = true;
                input.click();
              }
            });
          }
        }
        else {
          document.querySelectorAll('.option-selector__btns .option_index-3').forEach(function(input){
            if(!input.classList.contains('is-nonexistent')){
              new_variant_clicked = true;
              input.click();
            }
          });
          if(!new_variant_clicked){
            document.querySelectorAll('.option-selector__btns .option_index-2').forEach(function(input){
              if(!input.classList.contains('is-nonexistent')){
                new_variant_clicked = true;
                input.click();
              }
            });
          }
          if(!new_variant_clicked){
            var clicked_option1 = '';
            document.querySelectorAll('.option-selector__btns .option_index-1').forEach(function(input){
              if(input.checked){
                clicked_option1 = input.value;
              }
            });
            var this_variant_picker = this;
            var inputSelector = this.querySelector('.option-selector .option-selector__btns input');
            if (inputSelector) {
              var product_id = inputSelector.getAttribute('product_id');
              if (product_id && typeof availableVariantsMap !== 'undefined' && availableVariantsMap[product_id]) {
                var found_variant = false;
                availableVariantsMap[product_id]["option1"].some(function(variant) {
                  if(!found_variant){
                    if(variant.option1 == clicked_option1){
                      found_variant = true;
                      this_variant_picker.querySelectorAll('.option-selector .option-selector__btns .option_index-2').forEach(function(input){
                        if(input.value == variant.option2){
                          input.click();
                        }
                      });
                    }
                  }
                });
              }
            }
          }
        } */
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        if (priceWasEl)
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (typeof unitPrices !== 'undefined' && unitPrices[this.variant.id]) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = unitPrices[this.variant.id];
          const unit = units[this.variant.id];
          valueEl.innerHTML = unitPrices[this.variant.id];
          unitEl.textContent = value === 1 ? unit : `${unit}`;
          unitPriceEl.hidden = !unitPrices[this.variant.id];
        } else {
          unitPriceEl.hidden = true;
        } 

        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
    }


    /**
     * Updates Sections with Fetching.
     */
    updateSectionsWithFetching() {
      const newUrl = new URL(window.location.href);
      const id = this.variant ? this.variant.id : null;
      if (id) {
        newUrl.searchParams.set("variant", id);
      } else {
        newUrl.searchParams.delete("variant");
      }
      fetch(newUrl.toString())
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        if(html.querySelector('#delivery-status')){
          const delivery_status = html.querySelector('#delivery-status');
          document.querySelector('#delivery-status').innerHTML = delivery_status.innerHTML;
        }
        var selectedModel = '';
        var chosenColor = '';
        if(document.getElementById('herstellernummer-radio')){
          var herstellerInput = document.getElementById('herstellernummer-radio');

          document.querySelectorAll('.option_selector_modell input').forEach(function(input){
            if(input.checked){
              selectedModel = input.value;
            }
          });
          document.querySelectorAll('.custom_option-selector--combined-listing input').forEach(function(input){
            if(input.checked){
              chosenColor = input.value;
            }
          });

          const match = manufactors_json.find(
            (item) => item.modell === selectedModel && item.color === chosenColor
          );
          if (match) {
            herstellerInput.value = match.manufactor_id;
          } else {
            herstellerInput.value = "";
          }
        }

        /*
        const variantPickerDestination = document.querySelector('variant-picker') || document.querySelector('variant-selects');
        const variantPickerSource = html.querySelector('variant-picker') || html.querySelector('variant-selects');

        if (variantPickerSource && variantPickerDestination) variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
        */
       

      });
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          selectedOptions.push(selector.querySelector('input:checked').value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
